module.exports = __webpack_public_path__ + "media/src/website/images/locations/kufstein/kufstein_02-3b6ea138f1f0491f51be1c7102c2f062.jpg";